import React from "react";
import { render } from "react-dom";

import Root from "./containers/Root";
import { store } from "./store/createStore";
import MomentUtils from "@date-io/moment";
import MuiPickersUtilsProvider from "@material-ui/pickers/MuiPickersUtilsProvider";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { createMuiTheme } from "@material-ui/core/styles";
import LoginComponent from "../login/components/Login.Component";

var theme = createMuiTheme({
  palette: {
    primary: { main: "#395a5a" },
    secondary: { main: "#ef8a00" },
    buttons: { main: "#395a5a" },
  },
  overrides: {
    MuiButton: {
      root: {
        margin: "3px",
      },
      contained: {
        backgroundColor: "#ffffff",
      },
    },
    MuiTabs: {
      root: {
        color: "#fff",
        backgroundColor: "#395a5a",
      },
    },
    MuiOutlinedInput: {
      root: {
        marginBottom: "10px",
      },
    },
    MuiTextField: {
      root: {
        minWidth: "200px",
      },
    },
  },
});

if (isTokenDateValid()) {
  render(
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <MuiThemeProvider theme={theme}>
        <Root store={store} />
      </MuiThemeProvider>
    </MuiPickersUtilsProvider>,
    document.getElementById("AdminApp"),
  );
} else {
  render(<LoginComponent />, document.getElementById("AdminApp"));
}

function isTokenDateValid() {
  let jwt = localStorage.getItem("admin.usr");
  if (jwt) {
    let jwtExp = JSON.parse(jwt)["expires_in"];
    let dateNow = new Date().toUTCString();

    if (new Date(dateNow) < new Date(jwtExp)) {
      return true;
    }
  }
  return false;
}
